import React from 'react'
import styled from 'styled-components'

/** id del <main> reso da PageLayout: bersaglio del link di salto. */
export const MAIN_ID = 'contenuto-principale'

/**
 * Link di salto (WCAG 2.4.1 — bypass blocks).
 *
 * Va reso come PRIMO elemento focusabile del documento, prima dell'header:
 * se viene dopo, l'utente da tastiera deve comunque attraversare tutta la
 * navigazione per raggiungerlo e il link non serve a niente. Per questo vive
 * in App.tsx e non in PageLayout.
 */
export default function SkipLink() {
  return <StyledSkipLink href={`#${MAIN_ID}`}>Salta al contenuto principale</StyledSkipLink>
}

// Fuori schermo finche' non riceve il focus: comportamento atteso di uno skip link.
const StyledSkipLink = styled.a`
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: 10000000;
  background: #ffffff;
  color: #222222;
  font-weight: 700;
  padding: 1rem 1.5rem;
  border: 3px solid #005fcc;
  text-decoration: underline;

  &:focus {
    left: 0;
  }
`
